import { Card, useMediaQuery, useTheme } from '@mui/material';
import { useWorkflowDetailsHeaderStyles } from './workflow-details-header.styles';
import { LoadedActionsButtonItem } from '../actions-button/actions-button.types';
import { ActionsButton } from '../actions-button/actions-button.component';
import { SVGIconComponent } from '../icons/types';
import { StatusBadge } from '../status-badge/status-badge.component';
import { Colors } from '../../../theme/colors';
import { Deleted } from '../icons/Deleted.icon';

export interface WorkflowDetailsHeaderProps {
  workflowType: string;
  workflowReference?: string;
  WorkflowIcon?: SVGIconComponent;
  workflowStatus: string;
  bgColor: string;
  actions?: LoadedActionsButtonItem[];
  isDeleted?: boolean;
}

export function WorkflowDetailsHeader({
  actions,
  WorkflowIcon,
  workflowStatus,
  workflowType,
  workflowReference,
  bgColor,
  isDeleted
}: WorkflowDetailsHeaderProps) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const classes = useWorkflowDetailsHeaderStyles({ bgColor });

  return (
    <Card className={classes.root}>
      <table className={classes.table}>
        <tbody>
          <tr>
            <td className={classes.iconCol}>
              {WorkflowIcon ? <WorkflowIcon color="#FFFFFF" style={{ marginRight: '1rem' }} /> : null}
            </td>
            <td>
              <div className={classes.orderNumberColDiv}>
                <span className={classes.label}>{workflowType}</span>&nbsp;
                <span className={classes.mobileOrderStatusText}>{workflowStatus}</span>
              </div>
              <h4 className={classes.orderNumberText}>
                {isDeleted && isSmallScreen ? (
                  workflowReference ? (
                    <span>
                      ${workflowReference} <span className={classes.archived}>(ARCHIVED)</span>
                    </span>
                  ) : (
                    <span>
                      - <span className={classes.archived}>(ARCHIVED)</span>
                    </span>
                  )
                ) : workflowReference ? (
                  workflowReference
                ) : (
                  <>&nbsp;</>
                )}
              </h4>
            </td>
            {isDeleted && !isSmallScreen ? (
              <td>
                <StatusBadge color={Colors.cancelledDeletedRed} label="ARCHIVED" cornerRounding="max" Icon={Deleted} />
              </td>
            ) : null}
            <td className={classes.orderStatusCol}>
              <span>{workflowStatus}</span>
            </td>
            {actions && actions.length > 0 ? (
              <td className={classes.actionButtonCol}>
                <ActionsButton itemArray={actions} />
              </td>
            ) : null}
          </tr>
        </tbody>
      </table>
    </Card>
  );
}
